import { useCallback, useContext } from "react";
import { findIndex, keyBy, maxBy, sortBy } from "lodash";

import { swap } from "utils";

import { ScreenContext } from "..";

export function useScreenManager() {
  const { store, dispatch } = useContext(ScreenContext);

  const front = useCallback(() => {
    return maxBy(Object.values(store.zMap), "z")?.screen;
  }, [store.zMap]);

  const promote = useCallback(
    (screen) => {
      if (!(screen in store.zMap)) return;

      const zList = sortBy(Object.values(store.zMap), "z");
      if (zList[zList.length - 1].screen === screen) return;

      const newOrder = swap(
        zList,
        findIndex(zList, { screen }),
        zList.length - 1
      ).map(({ z, ...props }, i) => {
        return { ...props, z: i + 1 };
      });

      dispatch({
        type: "set-z-index",
        value: keyBy(newOrder, "screen"),
      });
    },
    [store.zMap, dispatch]
  );

  const isRegistered = useCallback(
    (screen) => {
      return screen in store.zMap;
    },
    [store.zMap]
  );

  const unregister = useCallback(
    (screen) => {
      if (!(screen in store.zMap)) return;
      dispatch({ type: "remove-z-index", value: { screen } });
    },
    [store.zMap, dispatch]
  );

  return { front, promote, isRegistered, unregister };
}

export default useScreenManager;
